
import React , { useState,useEffect }from 'react'
import { message,Popover,Select} from 'antd';
import { ProCard, StatisticCard } from '@ant-design/pro-components';
import RcResizeObserver from 'rc-resize-observer';
import {api_dashboard, api_dashboard_order, api_dashboard_cand, api_dashboard_admin} from '../../api';
import { localStorageGet } from '../../utils/global.js';
import "./index.css"
import Candtrace from './components/candtrace';

const { Statistic } = StatisticCard;

// const screenWidth = window.innerWidth;
// const screenHeight = window.innerHeight;

const App = () => {
  const [consoleData,setConsoleData] = useState({});
  // const [totalData,setTotalDataData] = useState({});
  const [orderTotalData,setOrderTotalData] = useState(0);
  const [orderConsoleData,setOrderConsoleData] = useState({});
  const [candTotalData,setCandTotalData] = useState(0);
  const [candConsoleData,setCandConsoleData] = useState({});
  const [responsive, setResponsive] = useState(false);
  const [tenantList, setTenantList] = useState([]);
  const [curTenantID, setCurTenantID] = useState("");
  const [loading, setLoading] = useState(true);

  const currentUserinfo = localStorageGet('UserInfo_k');
  
  useEffect(() => {
    // getConsoleData();
    if(currentUserinfo.roleid=='99')
      getConsoleData_admin();
    else{
      getConsoleData_order(curTenantID);
      getConsoleData_cand(curTenantID);
    }
  }, []);

  // const getConsoleData=async()=>{
  //   try {
  //     api_dashboard({}).then((res) => {
  //     console.log('api_dashboard-res-----------------', res);
  //     if (res.data.code == 9) {
  //       setConsoleData(res.data.list);
  //       setTotalDataData(res.data.total)
  //     }else
  //       message.error(res.data.msg);
  //     });
  //   } catch (error) {
  //       console.log('catch-error2 ---------- ', error)
  //       // return false;
  //   }
  // }

  const getConsoleData_order=async(tenant_id)=>{
    try {
      setLoading(true);
      api_dashboard_order({tenant_id:tenant_id}).then((res) => {
      console.log('api_dashboard_order-res-----------------', res);
      if (res.data.code == 9) {
        setOrderConsoleData(res.data.list);
        setOrderTotalData(res.data.total)
      }else
        message.error(res.data.msg);
      setLoading(false);
      });
    } catch (error) {
        console.log('catch-error2 ---------- ', error)
        message.error("异常-"+error);
        setLoading(false);
        // return false;
    }
  }

  const getConsoleData_cand=async(tenant_id)=>{
    try {
      setLoading(true);
      api_dashboard_cand({tenant_id:tenant_id}).then((res) => {
      console.log('api_dashboard_cand-res-----------------', res);
      if (res.data.code == 9) {
        setCandConsoleData(res.data.list);
        setCandTotalData(res.data.total)
      }else
        message.error(res.data.msg);
      setLoading(false);
      });
    } catch (error) {
        console.log('catch-error2 ---------- ', error)
        message.error("异常-"+error);
        setLoading(false);
        // return false;
    }
  }

  const getConsoleData_admin=async()=>{
    try {
      setLoading(true);
      api_dashboard_admin({}).then((res) => {
      console.log('api_dashboard_admin-res-----------------', res);
      if (res.data.code == 9) {
        setConsoleData(res.data.list);
        setTenantList(res.data.tenant_list);
      }else
        message.error(res.data.msg);
      setLoading(false);
      });
    } catch (error) {
        console.log('catch-error2 ---------- ', error)
        message.error("异常-"+error);
        setLoading(false);
        // return false;
    }
  }

  const onSlectTenant = (value) => {
    console.log(`selected ${value}`);
    setCurTenantID(value);
    getConsoleData_order(value);
    getConsoleData_cand(value);
  };
  
  return(
  <div>
    {currentUserinfo.roleid=='99'? 
    <div>
      <span style={{fontSize:16}}>请选择租户：</span>
      <Select
        style={{
          width: 160,
          // float:"right",
          // top:-60
          marginTop:20,
          marginBottom:20
        }}
        onChange={onSlectTenant}
        options={tenantList}
        value={curTenantID}
        fieldNames={{label:"tenant_name",value:"tenant_id"}}
      />
    </div>
    :""
    }
    {
      currentUserinfo.roleid=='99' && !curTenantID ? 
          <RcResizeObserver
            key="resize-observer"
            onResize={(offset) => {
              setResponsive(offset.width < 596);
            }}
          >
            <ProCard split={responsive ? 'horizontal' : 'vertical'}>
              {consoleData ? Object.keys(consoleData).map(key => 
              <StatisticCard
                colSpan={responsive ? 24 : 6}
                title={consoleData[key].name}
                loading={loading}
                statistic={{
                  value: consoleData[key].c,
                  valueStyle: {color:"#1890ff"}
                  // suffix: '亿',
                  // description: <Statistic title="日同比" value="6.47%" trend="up" />,
                }}
                // footer={
                //   <>
                //     {orderConsoleData[key].list ? Object.keys(orderConsoleData[key].list).map(index =>
                //       <Statistic
                //         value={orderConsoleData[key].list[index].c}
                //         title={orderConsoleData[key].list[index].name}
                //         layout="horizontal"
                //       />
                //     ):""
                //     }
                //   </>
                // }
              />)
              :'' }
            </ProCard>
          </RcResizeObserver>
      :
    <>
      <div className='board-title'>工单数据 【共 {orderTotalData} 单】</div>
      <RcResizeObserver
        key="resize-observer"
        onResize={(offset) => {
          setResponsive(offset.width < 596);
        }}
      >
        <ProCard split={responsive ? 'horizontal' : 'vertical'}>
          {orderConsoleData ? Object.keys(orderConsoleData).map(key => 
          <StatisticCard
            colSpan={responsive ? 24 : 6}
            title={orderConsoleData[key].name}
            loading={loading}
            statistic={{
              value: orderConsoleData[key].c,
              valueStyle: {color:"#1890ff"}
              // suffix: '亿',
              // description: <Statistic title="日同比" value="6.47%" trend="up" />,
            }}
            footer={
              <>
                {orderConsoleData[key].list ? Object.keys(orderConsoleData[key].list).map(index =>
                  <Statistic
                    value={orderConsoleData[key].list[index].c}
                    title={orderConsoleData[key].list[index].name}
                    layout="horizontal"
                  />
                ):""
                }
              </>
            }
          />)
          :'' }
        </ProCard>
      </RcResizeObserver>
      <div className='board-title'>候选人数据 【共 {candTotalData} 人】</div>
      <RcResizeObserver
        key="resize-observer"
        onResize={(offset) => {
          setResponsive(offset.width < 596);
        }}
      >
        <ProCard split={responsive ? 'horizontal' : 'vertical'}>
          {candConsoleData ? Object.keys(candConsoleData).map(key => 
          <StatisticCard
            colSpan={responsive ? 24 : 6}
            title={candConsoleData[key].name}
            loading={loading}
            statistic={{
              value: candConsoleData[key].c,
              valueStyle: {color:"#1890ff"}
              // suffix: '亿',
              // description: <Statistic title="日同比" value="6.47%" trend="up" />,
            }}
            footer={
              <>
                {candConsoleData[key].list ? Object.keys(candConsoleData[key].list).map(index =>
                  <>
                  <Statistic
                    title={candConsoleData[key].list[index].name} 
                    value={candConsoleData[key].list[index].c}
                    layout="horizontal"
                  />
                  {candConsoleData[key].list[index].list ? 
                      Object.keys(candConsoleData[key].list[index].list).map(k => 
                        <Statistic style={{marginLeft:14}}
                          title={<span style={{color:"rgb(0,0,0,.5)",fontSize:12}}>{candConsoleData[key].list[index].list[k].name}</span>}
                          value={candConsoleData[key].list[index].list[k].c} 
                          valueStyle={{color:"rgb(0,0,0,.5)",fontSize:12}}
                          layout="horizontal"
                        /> 
                        )
                      :""}
                  </>
                ):""
                }
              </>
            }
          />)
          :'' }
        </ProCard>
      </RcResizeObserver>
      <div className='board-title'>候选人任务溯源</div>
      <Candtrace
        tenant_id={curTenantID}
      />
    </>
    }
    </div>
)};
export default App;